import { Text, useToken } from '@chakra-ui/react'
import { formatPrice } from 'BrokerTsLib/src/Utils/formatPrice'
import { CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'
import { Card, CardBody } from '../components/Card'


const CustomTooltip = ({ active, payload, label }: any) => {
  if (active && payload && payload.length) {
    return (
      <Card>
        <CardBody sx={{ p: 2 }}>
          <Text>{`${label}: ${formatPrice({ price: payload[0].value, zeroLabel: '0 Kč' })}`}</Text>
        </CardBody>
      </Card>
    )
  }

  return null
}

export type CustomLineChartProps = {
  data: {
    name: string
    value: number
  }[]
}

export const CustomLineChart = ({ data }: CustomLineChartProps) => {
  const primaryColor = useToken('colors', 'primary.500')

  return (
    <ResponsiveContainer height={400} width="100%">
      <LineChart data={data}>
        <CartesianGrid stroke="#f0f0f0" />
        <XAxis dataKey="name" fontSize="11px" tickMargin={10} tickSize={0} />
        <YAxis
          fontSize="11px"
          tickMargin={10}
          tickSize={0}
          width={80}
          tickFormatter={(value) => formatPrice({ price: value, zeroLabel: '0 Kč' })}
        />
        <Tooltip content={(props) => <CustomTooltip {...props} />} />
        <Line type="monotone" dataKey="value" stroke={primaryColor} strokeWidth={2} />
      </LineChart>
    </ResponsiveContainer>
  )
}
